import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import clsx from 'clsx';
import StyledBox from './styles';
import useFreeResiliationFormulaContext from '../../../../Contexts/FreeResiliationFormulaContext/useFreeResiliationFormulaContext';

export default function Savings() {
  const {
    currentOfferCost, terminationFees, savings, newOfferCost,
  } = useFreeResiliationFormulaContext();
  const { i18n, t } = useTranslation('wysiwyg');
  const signedCurrencyFormat = new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'EUR', signDisplay: 'always' });
  const currencyFormat = new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'EUR' });

  if (currentOfferCost === undefined || terminationFees === undefined || savings === undefined || newOfferCost === undefined) return null;

  return (
    <StyledBox>
      <Typography variant="subtitle1" className={clsx({ negative: savings.result < 0 })}>
        <Trans
          t={t}
          values={{ total: signedCurrencyFormat.format(savings.result), count: currentOfferCost.commitmentLeft || 12 }}
          components={{ 1: <strong className={clsx('number', { negative: savings.result < 0 })} />, 2: <strong /> }}
          i18nKey="resiliation-fee.results.savings"
        />
      </Typography>
      <Box>
        <Typography className={clsx('number', { negative: savings.result < 0 })}>{signedCurrencyFormat.format(savings.result)}</Typography>
        <Typography variant="body2">=</Typography>
        <Typography data-step-number={1}>{currencyFormat.format(currentOfferCost.total)}</Typography>
        <Typography>-</Typography>
        <Typography data-step-number={2}>{currencyFormat.format(terminationFees.amountAfterReimbursement ?? terminationFees.amountToPay)}</Typography>
        <Typography>-</Typography>
        <Typography data-step-number={3}>{currencyFormat.format(newOfferCost.total)}</Typography>
      </Box>
    </StyledBox>
  );
}
